<template>
<div class="features tw-flex tw-flex-col tw-items-center amount-requested tw-px-4 lg:tw-pt-20 lg:tw-mb-0 tw-mb-48">
    <div class="tw-flex tw-flex-col tw-items-center tw-mt-6 tw-w-full">
    <title-section 
    title="Características"></title-section>
    <span class="optional tw-mb-6">(opcional)</span>
    <p class="tw-mb-8">Características de la vivienda</p>
    <div class="features-container">
        <div class="tw-flex tw-flex-col" 
        v-for="(feature, index) in features" :key="index">
                <div class="control-group input-container tw-flex tw-mb-6" :for="feature.index" @click="featureSelected($event, feature)">
                    <label class="control control-checkbox tw-px-5 tw-py-8 tw-w-full tw-h-full">
                        <span class="tw-pt-2">{{feature.name}}</span>
                            <input type="checkbox" 
                            :id="feature.index"
                            name="feature"
                            :value="feature"
                            @click="featureSelected($event, feature)"/>
                        <div class="control_indicator"></div>
                    </label>
                </div>
        </div>
    </div>
    <div class="fixed-button-mobile tw-mt-8">
        <button
            @click="goNextStep()"
            class="btn btn-primary fixed-button btn-steps tw-flex tw-items-center tw-justify-center"
        
        >
            Siguiente
        </button>
    </div>
</div></div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
data: () => ({
    features: [
        {
            id: 1,
            name: "Exterior"
        },
        {
            id: 2,
            name: "Ascensor"
        },
        {
            id: 3,
            name: "Garaje"
        },
        {
            id: 4,
            name: "Trastero"
        },
        {
            id: 5,
            name: "Terraza"
        },
        {
            id: 6,
            name: "Aire acondicionado"
        },
        {
            id: 7,
            name: "Piscina"
        },
        {
            id: 8,
            name: "Jardín"
        },
        {
            id: 9,
            name: "Área deportiva"
        }
    ],
    featuresSelected: []
}),
computed: {
    ...mapMutations(["selectFloor"]),
    ...mapGetters({
    wizard: "getWizard",
    }),
},
methods: {
    ...mapMutations(["selectFeatures"]),
    goNextStep(){
    let clearArray = [ ...new Set(this.featuresSelected) ]
    this.selectFeatures(clearArray);
    this.$router.push({ name: "State" });
    },
    featureSelected(event, feature){
        event.target.checked ? this.featuresSelected.push(feature.name) : '';
    }
},
};
</script>
    
<style lang="scss">
@import "../../../sass/variables";
.features {
    .input-container {
        cursor: pointer;
        width: 498px;
        box-shadow: 0 6px 13px -5px rgba(129, 143, 166, 0.2);
        border: solid 0.5px $color-grey-6;
        @media(max-width: $lg){
            width: 100%;
        }
    }
    .btn-steps {
        @media(max-width: $lg){
            left: 3%;
        }
    }

    .features-container {
        @media(max-width: $lg){
            width: 100%;
        }
    }

    .fixed-button-mobile {
        @media(max-width: $lg){
            justify-content: center;
        }
    }
}

.control {
    font-family: arial;
    display: block;
    position: relative;
    padding-left: 40px;
    margin-bottom: 5px;
    padding-top: 3px;
    cursor: pointer;
    font-size: 16px;
}
    .control input {
        position: absolute;
        z-index: -1;
        opacity: 0;
    }
.control_indicator {
    position: absolute;
    left: 15px;
    top: 19px;
    height: 24px;
    width: 24px;
    background: transparent;
    border: 1px solid $border-chip;
    border-radius: 6px;
}

.control input:checked ~ .control_indicator {
    background: $color-red-1;
}
.control_indicator:after {
    box-sizing: unset;
    content: '';
    position: absolute;
    display: none;
}
.control input:checked ~ .control_indicator:after {
    display: block;
}
.control-checkbox {
    padding: 2rem 1.5rem;
    margin-bottom: 0;
    span {
        padding-left: 4rem;
    }
}
.control-checkbox .control_indicator:after {
    left: 9px;
    top: 5px;
    width: 3px;
    height: 8px;
    border: solid $color-white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

</style>
      